import * as React from 'react';
import { Divider } from '../../elements/Divider';
import Dropzone from '../Dropzone';
import { Button, ButtonVariant } from '../../elements/Button';
import { ImportLocationsHeader } from './ImportLocationsHeader';

const spreadsheetTemplateLink =
  'https://xplortech.sharepoint.com/:x:/r/sites/FWProduct-MTProduct/Shared%20Documents/Product/External%20Docs/Location%20Creation%20in%20Bulk%20Template.xlsx?d=w3f643570d0e9466db946ad6f0cd6e88e&csf=1&web=1&e=woIOvb';

interface LocationsDocumentUploadProps {
  onDocumentSelect: (acceptedFiles: File[]) => void;
  uploadInProcess: boolean;
  onCancel: () => void;
  open?: () => void;
  isOpenInput: boolean;
  setIsOpenInput: React.Dispatch<React.SetStateAction<boolean>>;
}

const LocationsDocumentUpload = ({
  onDocumentSelect,
  onCancel,
  uploadInProcess,
  open,
  isOpenInput,
  setIsOpenInput,
}: LocationsDocumentUploadProps) => {
  return (
    <div className='flex flex-col font-sans border rounded-lg w-full h-full justify-between items-center'>
      <ImportLocationsHeader />
      <div className='p-4'>
        <p className='text-gray-800 text-sm mt-2 mb-4'>
          <span>
            Please use this
            <a
              href={spreadsheetTemplateLink}
              className='text-indigo-600 text-sm font-sans underline cursor-pointer ml-1 mr-1'
              target='_blank'
              download
              rel='noreferrer'
            >
              spreadsheet template
            </a>
            to upload all location information.
          </span>
        </p>
        <Divider />
        <div className='border-2 border-gray-light w-full h-36 mt-4 flex items-center justify-center '>
          <Dropzone
            onOpen={onDocumentSelect}
            isLoading={uploadInProcess}
            openFile={open}
            isOpen={isOpenInput}
            setIsOpen={setIsOpenInput}
          />
        </div>
      </div>
      <div className='w-full flex p-4 pt-0 justify-between'>
        <Button
          label='Cancel'
          onClick={onCancel}
          variant={ButtonVariant.Ghost}
          dataTestId='cancel-button'
        />
        <Button
          variant={ButtonVariant.Default}
          label='Upload CSV'
          className='w-[150px]'
          disabled
        />
      </div>
    </div>
  );
};

export default LocationsDocumentUpload;
